import { render, staticRenderFns } from "./BigGoal.vue?vue&type=template&id=bf7d0ec0&scoped=true"
import script from "./BigGoal.vue?vue&type=script&lang=js"
export * from "./BigGoal.vue?vue&type=script&lang=js"
import style0 from "./BigGoal.vue?vue&type=style&index=0&id=bf7d0ec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7d0ec0",
  null
  
)

export default component.exports